import styled from 'styled-components';

export const Container = styled.div`
  /* display: grid;
  grid-template-rows: auto 1fr; */
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Wrapper = styled.main`
  overflow-x: hidden;
`;
